var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('top'),_vm._v(" "),_c('router-view',{key:_vm.$route.fullPath,style:({'--theme-color': _vm.themeColor,
    '--theme-bgcolor': _vm.themeBgColor,
    '--style-color': _vm.styleColor,
    '--style-bgcolor': _vm.styleBgColor,
    '--hoverStyle-color': _vm.hoverStyle,
    '--hoverStyle-bgcolor': _vm.hoverStyleBgColor,
    backgroundColor: _vm.themeBgColor,
    '--backgroundImage': _vm.backgroundImage,
    '--cover': _vm.cover,
    '--nav-color': _vm.navColor,
    '--detail-bgcolor': _vm.detailBgcolor})}),_vm._v(" "),_c('bottom')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24e851ae","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 